import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { UnityModule } from '@emorg-prd/ngx-unity';
import { PrivacyPolicyModalComponent } from './components/privacy-policy-modal/privacy-policy-modal.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    BreadcrumbsComponent,
    PrivacyPolicyModalComponent,
  ],
  imports: [RouterModule, CommonModule, UnityModule],
  exports: [
    RouterModule,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    BreadcrumbsComponent,
    PrivacyPolicyModalComponent,
  ],
})
export class SharedModule {}
